module.exports = __webpack_public_path__ + "static/media/ic_xiaoxun.67774435.png";